import React from "react";
import {
  SEO,
  PageLayout,
  Background,
  InternalLink,
  CallToActionBanner,
  Call,
  Content,
  ImageCollection,
  Reviews,
  Map,
} from "@bluefin/components";
import { Header, Button, Grid, Image } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout
          hero={
            <Background columns={2} stackable={true} className={"home-hero"}>
              <Background.Color color={"white"} textAlign={"left"}>
                <Header as={"div"} className={"h6"}>
                  Welcome To
                </Header>
                <Header as={"h1"}>{fishermanBusiness.name}</Header>
                <Button
                  primary={true}
                  size={"large"}
                  to={"/menu/"}
                  as={InternalLink}
                >
                  View Menu
                </Button>
              </Background.Color>
              <Background.Image
                images={getComponentFiles({
                  components: fishermanBusinessWebsitePage.components,
                  componentName: "HeroElement",
                })}
              />
            </Background>
          }
          subfooter={false}
          className={"home-page"}
        >
          <CallToActionBanner stackable={true}>
            <CallToActionBanner.CTA>
              <Call
                phoneNumber={fishermanBusiness.primaryLocation.phoneNumber}
                as={"button"}
                buttonColor={"primary"}
              />
            </CallToActionBanner.CTA>
          </CallToActionBanner>
          <Content stackable={true}>
            <Content.Image
              src={getComponentFiles({
                components: fishermanBusinessWebsitePage.components,
                componentName: "Content.Image",
                componentIdentifier: "about",
                numToSelect: 1,
              })}
            />
            <Content.Markup truncate={true} paragraphs={2} isMarkdown={false}>
              <div>
                <Content.Markup truncate={true} paragraphs={2}>
                  {fishermanBusiness.aboutMarkdown}
                </Content.Markup>
                <Grid
                  stackable={true}
                  verticalAlign={"middle"}
                  textAlign={"center"}
                  centered={true}
                  column={"4"}
                >
                  <Grid.Row stretched={true}>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/image-from-clipboard_1_evm2YkA.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/36E1FF56-5D50-405A-9BF5-7E903F1DCF01.jpg"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"small"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/IMG_2662.jpg"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"small"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/RestaurantGuru_Certificate1.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/Excellent_service_award_oGfY2YG.jpeg"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/Excellent_burger_award_QX9M3a3.jpeg"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/RestaurantGuru_Certificate1_fSsjtyH.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/IMG_5052.JPG"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/image-from-clipboard.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/image-from-clipboard_1.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/image-from-clipboard_2.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/awards-fast-eddies_LBTYGiA.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={4} textAlign={"center"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/fasteddiesdiner2/awards-fast-eddies_1_dTvDYiF.png"
                        }
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </Content.Markup>
          </Content>
          <ImageCollection
            images={getComponentFiles({
              components: fishermanBusinessWebsitePage.components,
              componentName: "ImageCollection",
              numToSelect: 2,
            })}
            as={"gallery"}
            centered={true}
            cutUnevenRows={true}
            smartImageGrouping={false}
            disable={"none"}
            header={""}
            numberOfRowDisplayItems={2}
          />
          <div className={"reviews-container"}>
            <Reviews
              reviews={fishermanBusiness.reviews.slice(0, 3)}
              as={"card"}
              buttonBasic={false}
              buttonSize={"medium"}
              centerHeader={true}
              cardInlinePhoto={"left"}
              header={"Reviews"}
              imageCircular={false}
              imageSize={"small"}
              itemButtonFloat={false}
              itemCenterContent={false}
              itemsDivided={false}
              itemsPerRow={3}
              linkAs={"none"}
              onlyEvenRows={true}
              showImage={true}
              verticalItemAlign={"left"}
            />
            <Button
              to={"/about/"}
              primary={true}
              size={"large"}
              as={InternalLink}
            >
              See More
            </Button>
          </div>
          <Map
            address={{
              street: fishermanBusiness.primaryLocation.street,
              city: fishermanBusiness.primaryLocation.city,
              state: fishermanBusiness.primaryLocation.state,
              zip: fishermanBusiness.primaryLocation.zipCode,
            }}
          />
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        phoneNumber
        street
        city
        state
        zipCode
      }
      aboutMarkdown
      reviews {
        author
        text
        link
      }
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
